import React from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";

export default class LearningPlanBuilderSidebar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="SidebarTitle">{I18n.t("admin.elements")}</div>
        <Droppable droppableId="sidebar" isDropDisabled={true}>
          {(provided) => (
            <ul ref={provided.innerRef} {...provided.droppableProps}>
              {this.props.items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, _snapshot) => (
                    <li
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      ref={provided.innerRef}
                      onClick={this.props.onAddItem.bind(this, item)}
                    >
                      <div className="BuilderElement">
                        <div className="icon">
                          <span className={"fa " + item.icon}></span>
                        </div>
                        <div className="ElementName">{item.name}</div>
                      </div>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </div>
    );
  }
}
